import { createContext } from "react";
import type { LabDto } from "../../../../customer-experience/src/lib/ShiOneClient";

export interface LabsApiContextValue {
  apiEndpoint?: string;
  useDefinitionsPayload?: boolean;
  // Defaults to false; set to true only when explicitly validating parity during migration work.
  compareLegacyAndDefinitionsPayloads?: boolean;
  hasLabRequestPermission?: boolean;
  getAllLabs: () => Promise<LabDto[] | undefined>;
  getLabsDefinition: () => Promise<LabDto[] | undefined>;
  // Loosely typed: CX (NSwag/ShiOneClient) and CS (Kiota/generated models) implementations
  // use different generated model shapes for these, so signatures are kept intentionally loose here.
  getLabFilterOptions?: (...args: any[]) => Promise<any>;
  getUserLabsData?: (...args: any[]) => Promise<any>;
  createOnDemandLabForUser?: (...args: any[]) => Promise<any>;
  requestLabAccess?: (...args: any[]) => Promise<any>;
  createUserOnDemandLabRequests?: (...args: any[]) => Promise<any>;
  downloadLabDocumentation?: (...args: any[]) => Promise<any>;
}

export const LabsApiContext = createContext<LabsApiContextValue | undefined>(
  undefined,
);
